<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}">
    <div class="position: relative;">
      <!-- .custom-company-objective === cco -->
      <div class="cco">
        <div class="ccop-content">
          <iSwitch size="large" v-model="Modal.isOpen">
            <span slot="open">ON</span>
            <span slot="close">OFF</span>
          </iSwitch>
          <!-- <span class="cco-info">点击{{ Modal.isOpen ? '关闭' : '开启'}}{{Modal.title}}</span> -->
          <span class="cco-info">seek cooperation</span>
          <div style="padding-top: 30px;" v-if="Modal.isOpen">
            <Input
              v-model="Modal.title"
              placeholder="请输入标题"
              style="width: 100%"
              :disabled="!Modal.isOpen"
            />
          </div>
          <div class="cco-wrapper" v-if="Modal.content && Modal.content.length && Modal.isOpen">
            <div v-for="(item, index) in Modal.content" :key="'cco-wrapper-item2-' + index">
              <template
                v-if="item.typeId === 1 ||item.typeId === 2 ||item.typeId === 3 || item.typeId === 4 || item.typeId === 5 || item.typeId === 6 || item.typeId === 7 || item.typeId === 8"
              >
                <customObjectiveType
                  v-model="item.value"
                  v-if="item.value"
                  :item="item"
                  :index="index"
                  :open="Modal.isOpen"
                  @changeModal="changeModal($event, index)"
                ></customObjectiveType>
              </template>

              <Row v-if="item.typeId === 9" style="padding-bottom: 20px;">
                <Col span="5">
                  <div class="cco-wrapper-label">{{item.key}}：</div>
                </Col>
                <Col span="17" class="cco-wrapper-box">
                  <Input
                    v-model="item.value"
                    :placeholder="item.placeholder"
                    :maxlength="10"
                    style="width: 100%"
                    :disabled="!Modal.isOpen"
                    @on-change="sendModalNow(index)"
                  />
                </Col>
                <Col span="2" class="cco-wrapper-label f-tar">{{item.unit}}</Col>
              </Row>
            </div>
          </div>
          <div class="f-tar" style="margin-top:20px;">
            <Button type="primary" @click="saveCustom()" :loading="loading">Save</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import customObjectiveType from "./components/custom-objective-type.vue";

export default {
  // 寻求代理
  name: "custom-company-objective",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    info: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          info: "寻求代理",
          type: 2,
          isOpen: true,
          title: "寻求代理",
          content: []
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      visible2: false
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    },
    currentSave(val, oldVal) {
      this.loading = val;
    }
  },
  computed: {
    type() {
      return this.Modal.config.type;
    },
    ...mapGetters({
      currentSave: "customCompanyModule/getCurrent",
      activeIndex: "customCompanyModule/getActiveIndex"
    })
  },
  created() {},
  methods: {
    ...mapMutations({
      setCurrent: "customCompanyModule/setCurrent",
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    ...mapActions({
      getActionType: "companyModule/getActionType"
    }),
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    linkTo() {
      const link = location.origin + "/#/exhibition/index/partner/allpartner";
      window.open(link);
    },
    changeModal(e, i) {
      let copyValue = JSON.parse(JSON.stringify(this.Modal));
      copyValue.content[i].value = e;
      this.$emit("sendModal", copyValue);
    },
    sendModalNow() {
      let copyValue = JSON.parse(JSON.stringify(this.Modal));
      this.$emit("sendModal", copyValue);
    },
    saveCustom() {
      this.setCurrent(true);
    }
  },
  components: {
    customObjectiveType
  }
};
</script> 
<style scoped lang="scss">
.cco {
  width: 100%;
  &-pop {
    padding: 20px;
    width: 250px;
  }
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  .ccop {
    &-title {
      padding: 20px 30px;
      font-size: 14px;
      color: #333;
      border-bottom: solid 1px #ddd;
    }
    &-link {
      position: absolute;
      right: 20px;
      top: 20px;
    }
    &-content {
      padding: 40px 50px;
      position: relative;
      .addlink {
        border: dashed 1px #bfbfbf;
        text-align: center;
        color: #1890ff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  &-wrapper {
    padding-top: 20px;
    font-size: 14px;
    color: #333;
    &-box {
      display: flex;

      &__item {
        width: 100%;
        padding: 5px;
        text-align: center;
        border-radius: 5px;
        border: solid 1px #bfbfbf;
        margin-bottom: 20px;
        position: relative;

        color: #fff;
        border-color: #fe781d;
        background: #fe781d;
        .icon-closec {
          position: absolute;
          color: red;
          top: -16px;
          right: -12px;
          font-size: 20px;
          cursor: pointer;
        }
        &.active {
          color: #fff;
          border-color: #fe781d;
          background: #fe781d;
        }
        p {
          width: calc(100% - 1px);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      &__item2 {
        color: #1890ff;
        width: calc(100% - 1px);
        padding: 5px;
        text-align: center;
        border-radius: 5px;
        border: dashed 1px #1890ff;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        margin-bottom: 20px;
        &.disable {
          background-color: #f3f3f3;
          color: #ccc;
          border-color: #ccc;
        }
      }
    }
    &-label {
      line-height: 31px;
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
